import { autoSuggest } from "@/services/mapbox";
import router from "@/router/index";

const KEY_REGEX = /^(Backspace|Key|Digit|Space|Minus|Plus|Comma|Period|Slash|Backslash)/g;

export default {
  data() {
    return {
      query: "",
      autoSuggestResults: [],
      highlightedSuggestResult: undefined
    };
  },
  methods: {
    updateAutoSuggest(e) {
      if (!KEY_REGEX.test(e.code)) return;

      if (this.query === "") {
        this.autoSuggestResults = [];
        return;
      }

      autoSuggest(this.query).then((addresses) => {
        this.autoSuggestResults = addresses;
      });
    },
    handleAutoSuggestKeys(e) {
      switch (e.code) {
        case "ArrowDown":
          e.preventDefault();
          this.highlightedSuggestResult = this.autoSuggestResults[
            this.autoSuggestResults.indexOf(this.highlightedSuggestResult) + 1
          ];
          break;
        case "ArrowUp":
          e.preventDefault();
          this.highlightedSuggestResult = this.autoSuggestResults[
            this.autoSuggestResults.indexOf(this.highlightedSuggestResult) - 1
          ];
          break;
        case "Enter":
          if (typeof this.highlightedSuggestResult !== "undefined") {
            e.preventDefault();
            router.push({
              name: "Address",
              params: {
                geohash: this.highlightedSuggestResult.geohash,
                slug: this.highlightedSuggestResult.slug
              }
            });
          }
          break;
        default:
          this.highlightedSuggestResult = undefined;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/autosuggest.js